import fetch from '../../fetch';

export async function processRapydRefund(reservationDetails) {
    try {
        const resp = await fetch('/rapyd-refund', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                reservationDetails
            }),
            credentials: 'include'
        });

        const { status, errorMessage, refundId, refundStatus } = await resp.json();
        
        return { 
            status, 
            errorMessage,
            refundId,
            refundStatus
        };
    } catch (error) {
        return {
            status: 400,
            errorMessage: error.message || 'Error processing Rapyd refund'
        };
    }
}
